import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { OtpVerifyEmail } from '../../../../components/public-user-component/auth/otp-verify-component/otp-verify-email/otp-verify-email';
import { OtpVerifySms } from '../../../../components/public-user-component/auth/otp-verify-component/otp-verify-sms/otp-verify-sms';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-otp-verify',
  imports: [OtpVerifyEmail, OtpVerifySms, CommonModule],
  templateUrl: './otp-verify.html',
  styleUrl: './otp-verify.scss',
})
export class OtpVerify implements OnInit {
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  method: string | null;
  fromPage = this.router.url.split('/')[1];

  constructor() {
    this.method = isPlatformBrowser(this.platformId) ? localStorage.getItem('otpMethod') : 'NONE';
  }
  ngOnInit() {
    if (this.method == 'NONE') {
      this.router.navigate(['/'], { replaceUrl: true });
    }
    if (this.fromPage == 'register' && isPlatformBrowser(this.platformId)) {
      const mobile = localStorage.getItem('registeredMobile') || '';
      if (!mobile) {
        this.router.navigate(['/register'], { replaceUrl: true });
        return;
      }
    } else if (this.fromPage == 'forgot-password' && isPlatformBrowser(this.platformId)) {
      const email = localStorage.getItem('forgotUsername') || '';
      if (!email) {
        this.router.navigate(['/login'], { replaceUrl: true });
        return;
      }
    }
  }
}
